
import config from "../../../constants/config.js";
let _getState = null;
let _tenantSettings = {};

// function to fetch the keycloak config by tenant ID
export const tenantByDomain = async (subDomain) => {
  const res = await fetch(`${config.SERVER_URL}/api/tenants/domain/${subDomain}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",

    }
  })

  return await res.json();

};

//function to get the subdomain from the browser current URL
export const getSubDomain = () => {
  const domain = window.location.hostname;
  let subDomain = "";
  if (
    domain.split(".")[0] === "example" ||
    domain.split(".")[0] === "lvh" ||
    domain.split(".")[0] === "www"
  ) {
    throw new Error("Invalid domain");
  } else {
    subDomain = domain.split(".")[0];
  }

  // Fonctionto verify if the url is a private IP 
  function isPrivateIP(ip) {
    return (
      ip.startsWith("10.") ||
      (ip.startsWith("172.") && parseInt(ip.split(".")[1]) >= 16 && parseInt(ip.split(".")[1]) <= 31) ||
      ip.startsWith("192.168.") ||
      ip === "127.0.0.1"
    );
  }

  if (domain.startsWith("localhost") || isPrivateIP(domain)) {
    subDomain = "dev";
  }

  return subDomain;
}



export const getKeycloakSettings = async () => {
  try {
    const subDomain = getSubDomain();
    const { tenant, tenantSettings, livekitUrl } = await tenantByDomain(subDomain);

    const keycloakSettings = {
      url: tenantSettings.keycloak_auth_server_url,
      realm: tenantSettings.keycloak_realm,
      clientId: tenantSettings.keycloak_resource
    }
    return {
      keycloakSettings,
      tenant,
      livekitUrl
    };

  } catch (error) {
    console.error('Application initialization failed:', error);
    throw error;
  }
};
export const bindStore = (store) => {
  _getState = store.getState;
};


// Handle cases where the data values are strings or numbers
const _formatValue = (value) => {
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') {
      value = true;
    } else if (value.toLowerCase() === 'false') {
      value = false;
    }
  }
  else if (!isNaN(Number(value))) {
    value = Number(value) === 0 ? false : true;
  }
  return value;
}

export const bindTenantSettings = (tenantSettings) => {
  Object.keys(tenantSettings).forEach((key) => {
    const value = tenantSettings[key];
    tenantSettings[key] = _formatValue(value);

  });
  _tenantSettings = tenantSettings || {};
};


export const tenantHasFeature = (featureName) => {

  if (_tenantSettings && Object.keys(_tenantSettings).length > 0) {
    return !!_tenantSettings[featureName];
  }
  if (_getState) {
    const state = _getState();
    const tenantSettings = state?.auth?.tenantSettings || {};
    return _formatValue(tenantSettings[featureName]);
  }

  console.warn("tenantHasFeature: no tenant settings available");
  return false;
};

export const hasPermission = (permName) => {
  if (!_getState) {
    console.warn("authUtils: store not bound yet");
    return false;
  }
  const state = _getState();
  const perms = Array.isArray(state?.auth?.permissions) ? state.auth.permissions : [];
  return perms.some(p => p?.name === permName);
};


export const createRoomHasPermission = (roomPermissions) => {
  return (permName) => {
    const userHasPermission = hasPermission(permName);
    const roomHasPermission = roomPermissions?.some((p) => p?.name === permName);
    return roomHasPermission && userHasPermission;
  }
}

export const veifyGuestToken = () => {
  try {
    const token = localStorage.getItem("token");
    const code = localStorage.getItem('code');
    const demoToken = localStorage.getItem("demoToken");
    const demoMapId = localStorage.getItem("demoMapId");
    const isConferenceGuest = localStorage.getItem("isConferenceGuest");
    if (!token) {
      if (isConferenceGuest) { 
        window.location.href = `/conference/guest/${code}`; 
      }
      if (code) { 
        if (isConferenceGuest) { 
        window.location.href = `/conference/guest/${code}`; 
        } else  {window.location.href = `/guest/${code}`;} }
      else if (demoToken) {
        window.location.href = `/guest/demo?d=${demoToken}`;
      } else if (demoMapId) {
        window.location.href = `/guest/demo/${demoMapId}`;
      }
      else {
        return false;
      }
    }
    // Split the token to get the payload part (second part)
    const payload = token.split('.')[1];

    // Base64 decode the payload (add padding if needed)
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    // Parse the payload and get the expiration time
    const decodedPayload = JSON.parse(jsonPayload);
    const exp = decodedPayload.exp;

    // Check if the token is expired (compare window.location.href = `/guest/${code}`;with current time in seconds)
    if (exp * 1000 < Date.now()) {
      
      if (code) { 
        if (isConferenceGuest) { 
        window.location.href = `/conference/guest/${code}`; 
      } else {window.location.href = `/guest/${code}`;} }
      else {
        if (demoToken) { window.location.href = `/guest/demo?d=${demoToken}`;}
         else if (demoMapId) window.location.href = `/guest/demo/${demoMapId}`;
      }
    }
    else {
      if (code || demoToken || demoMapId || isConferenceGuest) {
        return true;
      }
      else {
        return false;
      }
    }
  } catch (e) {
    // If there's an error decoding the token, consider it expired
    return true;
  }


}

export const clearLocalStorage = () => {
  localStorage.removeItem("name");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("mapId");
  localStorage.removeItem("isFirstLoad");
  localStorage.removeItem("isLogin");
  localStorage.removeItem("email");
  localStorage.removeItem("isLoginNormal");
  localStorage.removeItem("token");
  localStorage.removeItem("demoToken");
  localStorage.removeItem("demoMapId");
  localStorage.removeItem("code");
  localStorage.removeItem("isConferenceGuest");
}